import React, {ChangeEvent} from 'react';
import Select, {Styles} from "react-select";
import {OptionsType} from "react-select";
import {UpdateFilterCallback} from "../../types/updateFilterCallback";
import {FilterOption} from "../../types/filterOption";
import {CustomDropdownIndicator} from "../Ui/CustomDropdownIndicator";
import {useTranslation} from "../../hooks/useTranslation";
import {Filter} from "../../types/filter";

type LocationFilterProps = {
    filter: Filter,
    categories: OptionsType<FilterOption>,
    updateFilter: UpdateFilterCallback
}

export function LocationFilter({filter, categories, updateFilter} : LocationFilterProps) {

    const translate = useTranslation();

    return (
        <div className="locationFilter flex-col">
            <div className="searchFilterContainer filterContainer col xsb-12 mb-6">
                <input
                    type="text"
                    placeholder={translate('filter_search_default')}
                    value={filter.name ?? ''}
                    onChange={(event : ChangeEvent<HTMLInputElement>) => updateFilter('name',  event.target.value)}
                />
            </div>

            <div className="col xsb-12 mb-6">
                <Select
                    placeholder={categories[0].label}
                    options={categories.slice(1)}
                    onChange={(val) => updateFilter('category', val === null ? null : (val as FilterOption).value)}
                    isClearable={true}
                    styles={customStyles}
                    className={'filterElement'}
                    components={{DropdownIndicator: CustomDropdownIndicator}}
                />
            </div>
        </div>
    );
}


const customStyles : Styles = {
    control: (provided, state) => ({
        ...provided,
        boxShadow: state.isFocused ? 'none' : 'none',
        borderRadius: 0,
        padding: '8px 15px',
        cursor: 'pointer',
        fontSize: 15,
        backgroundColor: state.isFocused ? '#FFFFFF' : '#FFFFFF',
        borderColor: state.isFocused ? '#a7a7a7' : '#a7a7a7',

        '&:hover': {
            borderColor: state.isFocused ? '#a7a7a7' : '#a7a7a7'
        },
    }),

    placeholder: base => ({
        ...base,
        color: '#464f56',
        fontSize: 15,
        lineHeight: 1.5
    }),

    clearIndicator: base => ({
        ...base,
        padding: '0 8px',
    }),

    indicatorSeparator: base => ({
        ...base,
        display: 'none',
    }),

    input: () => ({
        color: '#464f56',
        fontSize: 15,
        lineHeight: 1.5
    }),

    menu: (provided)  => ({
        ...provided,
        backgroundColor: '#FFF',
        border: '1px solid #a7a7a7',
        borderRadius: 0,
        margin: 0,
        zIndex: 100,
        padding: 0,
    }),

    option: (provided, state) => ({
        ...provided,
        color: state.isSelected ? '#FFF' : '#464f56',
        backgroundColor: state.isSelected ? '#4368a1' : '#FFF',
        padding: '10px 20px',
        cursor: 'pointer',
        fontSize: 15,

        '&:hover': {
            color: '#FFF',
            backgroundColor: state.isFocused ? '#4368a1' : '#4368a1',
        },
    }),
};

